module.exports = __webpack_public_path__ + "images/FUSA_icons/070-discount.34e4d7f0aba8884bcbe6e15062c3fc62.svg";